import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner tac"
}
const _hoisted_2 = {
  key: 1,
  class: "wageUpdateModalCard"
}
const _hoisted_3 = { class: "tar" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "수동조정여부", -1)
const _hoisted_5 = { class: "wageUpdateGubunDiv pl-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "사원정보", -1)
const _hoisted_7 = { class: "wageUpdateGubunDivReadOnly" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "임금기초", -1)
const _hoisted_9 = { class: "wageUpdateGubunDiv" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "과세임금", -1)
const _hoisted_11 = { class: "wageUpdateGubunDiv" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "연·야·휴 ( 시간 금액 연관계산 되지않음. )", -1)
const _hoisted_13 = { class: "wageUpdateGubunDiv" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "비과세임금", -1)
const _hoisted_15 = { class: "wageUpdateGubunDiv" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "합산임금관련", -1)
const _hoisted_17 = { class: "wageUpdateGubunDiv" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "근로자 공제", -1)
const _hoisted_19 = { class: "wageUpdateGubunDiv" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "tal" }, "기관 공제", -1)
const _hoisted_21 = { class: "wageUpdateGubunDiv" }

import { ref, watch } from "vue";
import axios from "axios";

export default /*#__PURE__*/_defineComponent({
  __name: 'WageLedgerManualModal',
  props: {
  item: {
    type: Object,
    required: true,
  },
  tax: {
    type: Object,
    required: true,
  },
  soji: {
    type: Object,
    required: true,
  },
},
  emits: ["success"],
  setup(__props, { emit: __emit }) {

const loading = ref(false);
const dialog = ref(false);
const form = ref([] as any);
const manual = ref(false);
const tax = ref([] as any);
const soji = ref([] as any);

// eslint-disable-next-line no-undef
const emit = __emit;
const props = __props;

const dialogOpen = async () => {
  form.value = (props.item);
  tax.value = props.tax;
  soji.value = props.soji;
  if(form.value.ew_manual === '1'){
    manual.value = true;
  }else {
    manual.value = false;
  }
  dialog.value = true;
};
const dialogClose = async () => {
  dialog.value = false;
};
watch([
  () => form.value.night, 
  () => form.value.overtime, 
  () => form.value.holiday, 
  () => form.value.nightHour, 
  () => form.value.overtimeHour, 
  () => form.value.holidayHour, 
  () => form.value.timePay,
  () => form.value.lunch,
  () => form.value.car,
  () => form.value.childcare,
  () => form.value.dang,
  () => form.value.dayOffPay,
  () => form.value.bonus,
  () => form.value.eduPay,
  () => form.value.longTerm,
  () => form.value.sunim,
  () => form.value.etc,
  () => form.value.bojon,
], ([
]) => {
    // form.value.night = ac(nc(nightHour) * nc(timePay) / 2) || 0;
    // form.value.overtime = ac(nc(overtimeHour) * nc(timePay) * 1.5) || 0;
    // form.value.holiday = ac(nc(holidayHour) * nc(timePay) / 2) || 0;


    // let onh = nc(form.value.night) + nc(form.value.overtime) + nc(form.value.holiday);

    // if(onh >= 200000){
    //   form.value.onhNonTax = '200,000';
    // }else{
    //   form.value.onhNonTax = ac(onh);
    // }

    form.value.base = 
   ac(
    nc(form.value.total) - 
    (nc(form.value.overtime) + 
    nc(form.value.night) + 
    nc(form.value.holiday) + 
    nc(form.value.longTerm) + 
    nc(form.value.sunim) +
    nc(form.value.etc) + 
    nc(form.value.lunch) + 
    nc(form.value.dang) +
    nc(form.value.dayOffPay) + 
    nc(form.value.bonus) + 
    nc(form.value.eduPay)  + 
    nc(form.value.car) + 
    nc(form.value.childcare) + 
    nc(form.value.bojon))); 

  form.value.usual = ac(nc(form.value.base) + nc(form.value.etc) + nc(form.value.car) + nc(form.value.childcare) + nc(form.value.bojon));
  form.value.taxable = ac(nc(form.value.total) - (nc(form.value.onhNonTax) + nc(form.value.lunch) + nc(form.value.dang) + nc(form.value.car) + nc(form.value.childcare)));
  form.value.minimum = ac(nc(form.value.base) + nc(form.value.etc) + nc(form.value.lunch) + nc(form.value.car) + nc(form.value.childcare) + nc(form.value.bojon));
  form.value.realMoney = ac(nc(form.value.total) - nc(form.value.l_total));
});

watch([
  () => form.value.l_so,
  () => form.value.l_ji,
  () => form.value.l_jiwon,
  () => form.value.l_sik,
  () => form.value.l_etc,
  () => form.value.l_yearEnd,
  () => form.value.longTerm,
  () => form.value.sunim,
  () => form.value.c_sil,
  () => form.value.c_san,
  () => form.value.c_out,

], ([
  l_so,
  l_ji,
  l_jiwon,
  l_sik,
  l_etc,
  l_yearEnd,
  longTerm,
  sunim,
  c_sil,
  c_san,
  c_out,
]) => {
    form.value.l_so = l_so || 0;
    form.value.l_ji = l_ji || 0;
    form.value.l_jiwon = l_jiwon || 0;
    form.value.l_sik = l_sik || 0;
    form.value.l_etc = l_etc || 0;
    form.value.l_yearEnd = l_yearEnd || 0;
    form.value.longTerm = longTerm || 0;
    form.value.sunim = sunim || 0;
    form.value.c_sil = c_sil || 0;
    form.value.c_san = c_san || 0;
    form.value.c_out = c_out || 0;


  form.value.l_total = ac(nc(form.value.l_yeon) + nc(form.value.l_gun) + nc(form.value.l_jang) + nc(form.value.l_go) + nc(form.value.l_so) + nc(form.value.l_ji) + nc(form.value.l_jiwon)+ nc(form.value.l_sik) + nc(form.value.l_etc) + nc(form.value.l_yearEnd));
  form.value.c_total = ac(nc(form.value.c_yeon) + nc(form.value.c_gun) + nc(form.value.c_jang) + nc(form.value.c_go) + nc(form.value.c_sil) + nc(form.value.c_san) + nc(form.value.c_out));
  form.value.realMoney = ac(nc(form.value.total) - nc(form.value.l_total));

});

watch([
  () => form.value.l_yeon, 
  () => form.value.l_gun, 
  () => form.value.l_jang, 
  () => form.value.l_go,
], ([
  l_yeon, 
  l_gun, 
  l_jang, 
  l_go,
]) => {
    form.value.l_yeon = l_yeon || 0;
    form.value.l_gun = l_gun || 0;
    form.value.l_jang = l_jang || 0;
    form.value.l_go = l_go || 0;
    form.value.c_yeon = l_yeon || 0;
    form.value.c_gun = l_gun || 0;
    form.value.c_jang = l_jang || 0;
    form.value.c_go = l_go || 0;
  form.value.l_total = ac(nc(form.value.l_yeon) + nc(form.value.l_gun) + nc(form.value.l_jang) + nc(form.value.l_go) + nc(form.value.l_so) + nc(form.value.l_ji) + nc(form.value.l_jiwon)+ nc(form.value.l_sik) + nc(form.value.l_etc) + nc(form.value.l_yearEnd));
  form.value.c_total = ac(nc(form.value.c_yeon) + nc(form.value.c_gun) + nc(form.value.c_jang) + nc(form.value.c_go) + nc(form.value.c_sil) + nc(form.value.c_san) + nc(form.value.c_out));
  form.value.realMoney = ac(nc(form.value.total) - nc(form.value.l_total));
});
watch([
  () => form.value.c_yeon,
  () => form.value.c_gun,
  () => form.value.c_jang,
  () => form.value.c_go,
], ([
  c_yeon,
  c_gun,
  c_jang,
  c_go,
]) => {
    form.value.c_yeon = c_yeon || 0;
    form.value.c_gun = c_gun || 0;
    form.value.c_jang = c_jang || 0;
    form.value.c_go = c_go || 0;
    form.value.l_yeon = c_yeon || 0;
    form.value.l_gun = c_gun || 0;
    form.value.l_jang = c_jang || 0;
    form.value.l_go = c_go || 0;
  form.value.l_total = ac(nc(form.value.l_yeon) + nc(form.value.l_gun) + nc(form.value.l_jang) + nc(form.value.l_go) + nc(form.value.l_so) + nc(form.value.l_ji) + nc(form.value.l_jiwon)+ nc(form.value.l_sik) + nc(form.value.l_etc) + nc(form.value.l_yearEnd));
  form.value.c_total = ac(nc(form.value.c_yeon) + nc(form.value.c_gun) + nc(form.value.c_jang) + nc(form.value.c_go) + nc(form.value.c_sil) + nc(form.value.c_san) + nc(form.value.c_out));
  form.value.realMoney = ac(nc(form.value.total) - nc(form.value.l_total));
});
const insuCalc = () => {
  let t = nc(form.value.taxable);
  let v = tax.value;
  if(form.value.l_yeon !== '0' ){
    form.value.l_yeon = ac(t * v.tr_yeon);
  }
  if(form.value.l_gun !== '0'){
    form.value.l_gun = ac(t * v.tr_gun);
  }
  if(form.value.l_jang !== '0'){
    form.value.l_jang = ac(t * v.tr_gun * v.tr_jang);
  }
  if(form.value.l_go !== '0'){
    form.value.l_go = ac(t * v.tr_go);
  }
  if(form.value.c_yeon !== '0'){
    form.value.c_yeon = ac(t * v.tr_yeon);
  }
  if(form.value.c_gun !== '0'){
    form.value.c_gun = ac(t * v.tr_gun);
  }
  if(form.value.c_jang !== '0'){
    form.value.c_jang = ac(t * v.tr_gun * v.tr_jang);
  }
  if(form.value.c_go !== '0'){
    form.value.c_go = ac(t * v.tr_go);
  }

  form.value.l_so = ac(getDepe1(t / 1000));
  form.value.l_ji = ac((getDepe1(t / 1000))/10);
  form.value.c_sil = ac(t * v.tr_sil);
  form.value.c_san = ac(t * v.tr_san);
  form.value.c_out = ac((nc(form.value.total)-nc(form.value.lunch))/12);
  form.value.realMoney = ac(nc(form.value.total) - nc(form.value.l_total));

}
function getDepe1(value: any) {
  for (let obj of soji.value) {
    if (value >= obj.income1 && value < obj.income2) {
      return obj.depe_1;
    }
  }
  return null;
}
const updateOneWageInfo = async () => {
  try {
    if(manual.value === true){
      form.value.ew_manual = '1'
    }else {
      form.value.ew_manual = '0'
    }
    const response = await axios.post("/api/updateOneWageInfo", { form: form.value });
    const result = response.data;
    if (result.success === true) {
      alert("수동조정이 완료되었습니다.");
      dialog.value = false;
      emit("success");
    } else {
      alert("수동조정에 실패하였습니다. 관리자에게 문의해주세요.");
    }
  } catch (error) {
    alert("처리할 수 없습니다.");
    console.error(error);
  }
};

function nc(value: any) {
  // value가 null 또는 undefined인 경우 빈 문자열로 처리
  if (value == null) {
    return 0;  // 기본값을 0으로 설정하거나 다른 적합한 값으로 설정
  }
  
  // 컴마를 제거하고 숫자로 변환
  return parseFloat(value.toString().replace(/,/g, ""));
}
function ac(value: any) {
  //1단위 절삭 후 컴마
  let num = Number(value);
  if (isNaN(num)) return 0;
  num = Math.floor(num / 10) * 10;
  return num.toLocaleString()  || 0;
}
function clearFormat(item: any, key: any) {
  // 인풋의 값을 컴마 없이 만듭니다.
  item[key] = unformatNumber(item[key]);

  // 값이 0이면 빈 값으로 설정하여 placeholder를 보이도록 합니다.
  if (item[key] === '0' || item[key] === '0.0' || item[key] === null || item[key] === '' || item[key] === undefined || item[key] === 0 || item[key] === '-0') {
    item[key] = '';
  }
}

function applyFormat(item: any, key: any) {
  // 값이 비어있으면 0으로 설정
  if (item[key] === '' || item[key] === null || item[key] === undefined || item[key] === '-0') {
    item[key] = 0;
  } else {
    // 포커스가 해제되면 천 단위로 컴마를 추가
    item[key] = formatNumber(item[key]);
  }
}

function formatNumber(value: any): string {
  // 숫자인지 확인하고 천 단위로 컴마 추가
  const number = parseFloat(value);
  if (!isNaN(number)) {
    return number.toLocaleString();
  }
  return value;
}

function unformatNumber(value: any) {
  // 컴마를 제거
  return value.toString().replace(/,/g, '');
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_icon, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogOpen()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-pen")
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[145] || (_cache[145] = ($event: any) => ((dialog).value = $event)),
      style: {"width":"900px"},
      class: "fontNotoSans400",
      persistent: ""
    }, {
      default: _withCtx(() => [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_icon, {
                  style: {"width":"35px","height":"35px"},
                  color: "#333",
                  onClick: dialogClose
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_switch, {
                  modelValue: manual.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((manual).value = $event)),
                  color: "primary",
                  label: "수동조정을 고정하고싶다면 체크해주세요.",
                  "hide-details": "",
                  inset: ""
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_text_field, {
                  readonly: "",
                  modelValue: form.value.sisulName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.sisulName) = $event)),
                  label: "시설명",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  readonly: "",
                  modelValue: form.value.empName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.empName) = $event)),
                  label: "사원이름",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  readonly: "",
                  modelValue: form.value.empJob,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.empJob) = $event)),
                  label: "사원직종",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  readonly: "",
                  modelValue: form.value.ym,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.ym) = $event)),
                  label: "임금연월",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[6] || (_cache[6] = ($event: any) => (clearFormat(__props.item, 'timePay'))),
                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (applyFormat(__props.item, 'timePay'))),
                  modelValue: form.value.timePay,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.timePay) = $event)),
                  label: "시급",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[9] || (_cache[9] = ($event: any) => (clearFormat(__props.item, 'totalDays'))),
                  onBlur: _cache[10] || (_cache[10] = ($event: any) => (applyFormat(__props.item, 'totalDays'))),
                  modelValue: form.value.totalDays,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.totalDays) = $event)),
                  label: "근무일",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[12] || (_cache[12] = ($event: any) => (clearFormat(__props.item, 'totalHours'))),
                  onBlur: _cache[13] || (_cache[13] = ($event: any) => (applyFormat(__props.item, 'totalHours'))),
                  modelValue: form.value.totalHours,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.totalHours) = $event)),
                  label: "근무시간",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[15] || (_cache[15] = ($event: any) => (clearFormat(__props.item, 'base'))),
                  onBlur: _cache[16] || (_cache[16] = ($event: any) => (applyFormat(__props.item, 'base'))),
                  modelValue: form.value.base,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.base) = $event)),
                  label: "기본급",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[18] || (_cache[18] = ($event: any) => (clearFormat(__props.item, 'dayOffPay'))),
                  onBlur: _cache[19] || (_cache[19] = ($event: any) => (applyFormat(__props.item, 'dayOffPay'))),
                  modelValue: form.value.dayOffPay,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.dayOffPay) = $event)),
                  label: "연차수당",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[21] || (_cache[21] = ($event: any) => (clearFormat(__props.item, 'longTerm'))),
                  onBlur: _cache[22] || (_cache[22] = ($event: any) => (applyFormat(__props.item, 'longTerm'))),
                  modelValue: form.value.longTerm,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.value.longTerm) = $event)),
                  label: "장기근속",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[24] || (_cache[24] = ($event: any) => (clearFormat(__props.item, 'sunim'))),
                  onBlur: _cache[25] || (_cache[25] = ($event: any) => (applyFormat(__props.item, 'sunim'))),
                  modelValue: form.value.sunim,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((form.value.sunim) = $event)),
                  label: "선임수당",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[27] || (_cache[27] = ($event: any) => (clearFormat(__props.item, 'bonus'))),
                  onBlur: _cache[28] || (_cache[28] = ($event: any) => (applyFormat(__props.item, 'bonus'))),
                  modelValue: form.value.bonus,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((form.value.bonus) = $event)),
                  label: "상여금",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[30] || (_cache[30] = ($event: any) => (clearFormat(__props.item, 'eduPay'))),
                  onBlur: _cache[31] || (_cache[31] = ($event: any) => (applyFormat(__props.item, 'eduPay'))),
                  modelValue: form.value.eduPay,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((form.value.eduPay) = $event)),
                  label: "교육비",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[33] || (_cache[33] = ($event: any) => (clearFormat(__props.item, 'bojon'))),
                  onBlur: _cache[34] || (_cache[34] = ($event: any) => (applyFormat(__props.item, 'bojon'))),
                  modelValue: form.value.bojon,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((form.value.bojon) = $event)),
                  label: "보존수당",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[36] || (_cache[36] = ($event: any) => (clearFormat(__props.item, 'etc'))),
                  onBlur: _cache[37] || (_cache[37] = ($event: any) => (applyFormat(__props.item, 'etc'))),
                  modelValue: form.value.etc,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((form.value.etc) = $event)),
                  label: "기타수당",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[39] || (_cache[39] = ($event: any) => (clearFormat(__props.item, 'nightHour'))),
                  onBlur: _cache[40] || (_cache[40] = ($event: any) => (applyFormat(__props.item, 'nightHour'))),
                  modelValue: form.value.nightHour,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((form.value.nightHour) = $event)),
                  label: "야간근무시간",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[42] || (_cache[42] = ($event: any) => (clearFormat(__props.item, 'night'))),
                  onBlur: _cache[43] || (_cache[43] = ($event: any) => (applyFormat(__props.item, 'night'))),
                  modelValue: form.value.night,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((form.value.night) = $event)),
                  label: "야간근무수당",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[45] || (_cache[45] = ($event: any) => (clearFormat(__props.item, 'overtimeHour'))),
                  onBlur: _cache[46] || (_cache[46] = ($event: any) => (applyFormat(__props.item, 'overtimeHour'))),
                  modelValue: form.value.overtimeHour,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((form.value.overtimeHour) = $event)),
                  label: "연장근무시간",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[48] || (_cache[48] = ($event: any) => (clearFormat(__props.item, 'overtime'))),
                  onBlur: _cache[49] || (_cache[49] = ($event: any) => (applyFormat(__props.item, 'overtime'))),
                  modelValue: form.value.overtime,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((form.value.overtime) = $event)),
                  label: "연장근무수당",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[51] || (_cache[51] = ($event: any) => (clearFormat(__props.item, 'holidayHour'))),
                  onBlur: _cache[52] || (_cache[52] = ($event: any) => (applyFormat(__props.item, 'holidayHour'))),
                  modelValue: form.value.holidayHour,
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((form.value.holidayHour) = $event)),
                  label: "휴일근무시간",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[54] || (_cache[54] = ($event: any) => (clearFormat(__props.item, 'holiday'))),
                  onBlur: _cache[55] || (_cache[55] = ($event: any) => (applyFormat(__props.item, 'holiday'))),
                  modelValue: form.value.holiday,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((form.value.holiday) = $event)),
                  label: "휴일근무수당",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[57] || (_cache[57] = ($event: any) => (clearFormat(__props.item, 'onhNonTax'))),
                  onBlur: _cache[58] || (_cache[58] = ($event: any) => (applyFormat(__props.item, 'onhNonTax'))),
                  modelValue: form.value.onhNonTax,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((form.value.onhNonTax) = $event)),
                  label: "연야휴 비과세 처리액",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[60] || (_cache[60] = ($event: any) => (clearFormat(__props.item, 'dang'))),
                  onBlur: _cache[61] || (_cache[61] = ($event: any) => (applyFormat(__props.item, 'dang'))),
                  modelValue: form.value.dang,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((form.value.dang) = $event)),
                  label: "당직수당",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[63] || (_cache[63] = ($event: any) => (clearFormat(__props.item, 'lunch'))),
                  onBlur: _cache[64] || (_cache[64] = ($event: any) => (applyFormat(__props.item, 'lunch'))),
                  modelValue: form.value.lunch,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((form.value.lunch) = $event)),
                  label: "중식대",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[66] || (_cache[66] = ($event: any) => (clearFormat(__props.item, 'car'))),
                  onBlur: _cache[67] || (_cache[67] = ($event: any) => (applyFormat(__props.item, 'car'))),
                  modelValue: form.value.car,
                  "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((form.value.car) = $event)),
                  label: "차량비",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[69] || (_cache[69] = ($event: any) => (clearFormat(__props.item, 'childcare'))),
                  onBlur: _cache[70] || (_cache[70] = ($event: any) => (applyFormat(__props.item, 'childcare'))),
                  modelValue: form.value.childcare,
                  "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((form.value.childcare) = $event)),
                  label: "양육비",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_v_text_field, {
                  readonly: "",
                  "bg-color": "#f1f1f1",
                  color: "blue-accent-4",
                  modelValue: form.value.total,
                  "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((form.value.total) = $event)),
                  label: "임금합계",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[73] || (_cache[73] = ($event: any) => (clearFormat(__props.item, 'taxable'))),
                  onBlur: _cache[74] || (_cache[74] = ($event: any) => (applyFormat(__props.item, 'taxable'))),
                  modelValue: form.value.taxable,
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((form.value.taxable) = $event)),
                  label: "과세임금",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[76] || (_cache[76] = ($event: any) => (clearFormat(__props.item, 'usual'))),
                  onBlur: _cache[77] || (_cache[77] = ($event: any) => (applyFormat(__props.item, 'usual'))),
                  modelValue: form.value.usual,
                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((form.value.usual) = $event)),
                  label: "통상임금",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[79] || (_cache[79] = ($event: any) => (clearFormat(__props.item, 'minimum'))),
                  onBlur: _cache[80] || (_cache[80] = ($event: any) => (applyFormat(__props.item, 'minimum'))),
                  modelValue: form.value.minimum,
                  "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((form.value.minimum) = $event)),
                  label: "최저임금",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[82] || (_cache[82] = ($event: any) => (clearFormat(__props.item, 'realMoney'))),
                  onBlur: _cache[83] || (_cache[83] = ($event: any) => (applyFormat(__props.item, 'realMoney'))),
                  modelValue: form.value.realMoney,
                  "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((form.value.realMoney) = $event)),
                  label: "실수령액",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_v_btn, {
                class: "btnColorDark",
                onClick: _cache[85] || (_cache[85] = ($event: any) => (insuCalc()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("공제자동계산")
                ]),
                _: 1
              }),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[86] || (_cache[86] = ($event: any) => (clearFormat(__props.item, 'l_yeon'))),
                  onBlur: _cache[87] || (_cache[87] = ($event: any) => (applyFormat(__props.item, 'l_yeon'))),
                  modelValue: form.value.l_yeon,
                  "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((form.value.l_yeon) = $event)),
                  label: "국민연금",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[89] || (_cache[89] = ($event: any) => (clearFormat(__props.item, 'l_gun'))),
                  onBlur: _cache[90] || (_cache[90] = ($event: any) => (applyFormat(__props.item, 'l_gun'))),
                  modelValue: form.value.l_gun,
                  "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((form.value.l_gun) = $event)),
                  label: "건강보험",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[92] || (_cache[92] = ($event: any) => (clearFormat(__props.item, 'l_jang'))),
                  onBlur: _cache[93] || (_cache[93] = ($event: any) => (applyFormat(__props.item, 'l_jang'))),
                  modelValue: form.value.l_jang,
                  "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((form.value.l_jang) = $event)),
                  label: "장기요양",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[95] || (_cache[95] = ($event: any) => (clearFormat(__props.item, 'l_go'))),
                  onBlur: _cache[96] || (_cache[96] = ($event: any) => (applyFormat(__props.item, 'l_go'))),
                  modelValue: form.value.l_go,
                  "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((form.value.l_go) = $event)),
                  label: "고용보험",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[98] || (_cache[98] = ($event: any) => (clearFormat(__props.item, 'l_so'))),
                  onBlur: _cache[99] || (_cache[99] = ($event: any) => (applyFormat(__props.item, 'l_so'))),
                  modelValue: form.value.l_so,
                  "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((form.value.l_so) = $event)),
                  label: "소득세",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[101] || (_cache[101] = ($event: any) => (clearFormat(__props.item, 'l_ji'))),
                  onBlur: _cache[102] || (_cache[102] = ($event: any) => (applyFormat(__props.item, 'l_ji'))),
                  modelValue: form.value.l_ji,
                  "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((form.value.l_ji) = $event)),
                  label: "지방세",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[104] || (_cache[104] = ($event: any) => (clearFormat(__props.item, 'l_jiwon'))),
                  onBlur: _cache[105] || (_cache[105] = ($event: any) => (applyFormat(__props.item, 'l_jiwon'))),
                  modelValue: form.value.l_jiwon,
                  "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => ((form.value.l_jiwon) = $event)),
                  label: "지원공제",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[107] || (_cache[107] = ($event: any) => (clearFormat(__props.item, 'l_sik'))),
                  onBlur: _cache[108] || (_cache[108] = ($event: any) => (applyFormat(__props.item, 'l_sik'))),
                  modelValue: form.value.l_sik,
                  "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((form.value.l_sik) = $event)),
                  label: "식비공제",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[110] || (_cache[110] = ($event: any) => (clearFormat(__props.item, 'l_etc'))),
                  onBlur: _cache[111] || (_cache[111] = ($event: any) => (applyFormat(__props.item, 'l_etc'))),
                  modelValue: form.value.l_etc,
                  "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((form.value.l_etc) = $event)),
                  label: "기타공제",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[113] || (_cache[113] = ($event: any) => (clearFormat(__props.item, 'l_yearEnd'))),
                  onBlur: _cache[114] || (_cache[114] = ($event: any) => (applyFormat(__props.item, 'l_yearEnd'))),
                  modelValue: form.value.l_yearEnd,
                  "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((form.value.l_yearEnd) = $event)),
                  label: "연말정산",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[116] || (_cache[116] = ($event: any) => (clearFormat(__props.item, 'l_total'))),
                  onBlur: _cache[117] || (_cache[117] = ($event: any) => (applyFormat(__props.item, 'l_total'))),
                  modelValue: form.value.l_total,
                  "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((form.value.l_total) = $event)),
                  label: "공제합계",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[119] || (_cache[119] = ($event: any) => (clearFormat(__props.item, 'c_yeon'))),
                  onBlur: _cache[120] || (_cache[120] = ($event: any) => (applyFormat(__props.item, 'c_yeon'))),
                  modelValue: form.value.c_yeon,
                  "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => ((form.value.c_yeon) = $event)),
                  label: "국민연금",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[122] || (_cache[122] = ($event: any) => (clearFormat(__props.item, 'c_gun'))),
                  onBlur: _cache[123] || (_cache[123] = ($event: any) => (applyFormat(__props.item, 'c_gun'))),
                  modelValue: form.value.c_gun,
                  "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((form.value.c_gun) = $event)),
                  label: "건강보험",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[125] || (_cache[125] = ($event: any) => (clearFormat(__props.item, 'c_jang'))),
                  onBlur: _cache[126] || (_cache[126] = ($event: any) => (applyFormat(__props.item, 'c_jang'))),
                  modelValue: form.value.c_jang,
                  "onUpdate:modelValue": _cache[127] || (_cache[127] = ($event: any) => ((form.value.c_jang) = $event)),
                  label: "장기요양",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[128] || (_cache[128] = ($event: any) => (clearFormat(__props.item, 'c_go'))),
                  onBlur: _cache[129] || (_cache[129] = ($event: any) => (applyFormat(__props.item, 'c_go'))),
                  modelValue: form.value.c_go,
                  "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event: any) => ((form.value.c_go) = $event)),
                  label: "고용보험",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[131] || (_cache[131] = ($event: any) => (clearFormat(__props.item, 'c_sil'))),
                  onBlur: _cache[132] || (_cache[132] = ($event: any) => (applyFormat(__props.item, 'c_sil'))),
                  modelValue: form.value.c_sil,
                  "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => ((form.value.c_sil) = $event)),
                  label: "실업급여",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[134] || (_cache[134] = ($event: any) => (clearFormat(__props.item, 'c_san'))),
                  onBlur: _cache[135] || (_cache[135] = ($event: any) => (applyFormat(__props.item, 'c_san'))),
                  modelValue: form.value.c_san,
                  "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => ((form.value.c_san) = $event)),
                  label: "산재보험",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[137] || (_cache[137] = ($event: any) => (clearFormat(__props.item, 'c_out'))),
                  onBlur: _cache[138] || (_cache[138] = ($event: any) => (applyFormat(__props.item, 'c_out'))),
                  modelValue: form.value.c_out,
                  "onUpdate:modelValue": _cache[139] || (_cache[139] = ($event: any) => ((form.value.c_out) = $event)),
                  label: "퇴직금",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  color: "blue-accent-4",
                  onFocus: _cache[140] || (_cache[140] = ($event: any) => (clearFormat(__props.item, 'c_total'))),
                  onBlur: _cache[141] || (_cache[141] = ($event: any) => (applyFormat(__props.item, 'c_total'))),
                  modelValue: form.value.c_total,
                  "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => ((form.value.c_total) = $event)),
                  label: "공제합계",
                  variant: "outlined",
                  "hide-details": "",
                  type: "text",
                  flat: "",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_v_btn, {
                onClick: _cache[143] || (_cache[143] = ($event: any) => (updateOneWageInfo())),
                class: "clientInfoBtn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("저장")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                onClick: _cache[144] || (_cache[144] = ($event: any) => (dialogClose())),
                class: "cancelRegistBtn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("취소")
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})